var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import Uploader from '../../../common/components/UploaderGood.vue';
import DeliverService from '../../../api/DeliverService';
import GoodService from '../../../api/GoodService';
var OCRUpload = (function (_super) {
    __extends(OCRUpload, _super);
    function OCRUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogImageUrl = '';
        _this.dialogWidth = '640px';
        _this.dialogVisible = false;
        _this.uploadFinished = false;
        _this.loading = true;
        _this.innerDrawer = false;
        _this.goodList = [];
        _this.unmatchedGoodList = [];
        _this.selectedGoodList = [];
        _this.similarGoodList = [];
        _this.otherOptionsBak = [];
        _this.matachedGood = null;
        _this.imageUrl = [];
        _this.limit = 1;
        _this.currentGood = '';
        return _this;
    }
    OCRUpload.prototype.uploadShowWatch = function (val) {
        if (val) {
        }
    };
    OCRUpload.prototype.created = function () {
        this.deliverService = DeliverService.getInstance();
        this.service = GoodService.getInstance();
    };
    OCRUpload.prototype.cellClassName = function (_a) {
        var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        console.log({ row: row, column: column, rowIndex: rowIndex, columnIndex: columnIndex });
        return this.checkChanged(row) ? 'spec_custom_column' : 'custom_column';
    };
    OCRUpload.prototype.customColumn = function (_a) {
        var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        return columnIndex === 1 && this.checkChanged(row) ? 'spec_custom_column' : 'custom_column';
    };
    OCRUpload.prototype.checkChanged = function (item) {
        return item.exists_order_goods_replace && item.supplier_goods_name === item.predict_goods_name;
    };
    OCRUpload.prototype.cancel = function () {
        this.initData();
        this.$emit('cancelDio', false);
    };
    OCRUpload.prototype.showAiResult = function () {
        this.uploadFinished = true;
        if (this.$refs.drawer) {
            this.$refs.drawer.closeDrawer();
        }
        this.dialogWidth = "1200px";
    };
    OCRUpload.prototype.handleRemove = function (file, fileList) {
        console.log(file, fileList);
        this.uploadFinished = false;
        this.dialogWidth = "640px";
        this.imageUrl = [];
    };
    OCRUpload.prototype.handlePictureCardPreview = function (file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        this.loading = false;
    };
    OCRUpload.prototype.formatRequestParams = function (imageList) {
        var supplier_to_business_id = this.ocrParams && this.ocrParams.supplier_to_business_id ? this.ocrParams.supplier_to_business_id : '';
        var goods_format_ids = this.ocrParams && this.ocrParams.goods_format_ids ? this.ocrParams.goods_format_ids : '';
        var formData = new FormData();
        formData.append('supplier_to_business_id', supplier_to_business_id);
        formData.append('goods_format_ids', goods_format_ids);
        if (imageList[0].isExcel) {
            formData.append('file', imageList[0].file);
        }
        else {
            formData.append('url', imageList[0].url);
        }
        return formData;
    };
    OCRUpload.prototype.editUploadSuccess = function (imageList) {
        if (this.$refs.drawer) {
            this.$refs.drawer.closeDrawer();
        }
        this.uploadFinished = false;
        this.dialogWidth = "640px";
        this.uploadSuccess(imageList);
    };
    OCRUpload.prototype.uploadSuccess = function (imageList) {
        var _this = this;
        this.imageUrl = imageList && imageList.length ? imageList : [];
        if (imageList && imageList.length) {
            var formData = this.formatRequestParams(imageList);
            this.deliverService.aiCreateGoodInfo(formData).then(function (res) {
                _this.showAiResult();
                if (res.data.success) {
                    _this.goodList = res.data.data && res.data.data.length ? (res.data.data.filter(function (item) { return +item.is_identify === 1; }) || []) : [];
                    _this.unmatchedGoodList = res.data.data && res.data.data.length ? (res.data.data.filter(function (item) { return +item.is_identify !== 1; }) || []) : [];
                    _this.computeGoodList();
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }, function (err) {
                _this.$message.error(err.message);
                _this.showAiResult();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                _this.showAiResult();
            });
        }
    };
    OCRUpload.prototype.computeGoodList = function () {
        var _this = this;
        this.otherOptionsBak = [];
        if (this.goodList && this.goodList.length) {
            this.goodList.forEach(function (item, index) {
                item.amount = item.predict_goods_amount ? item.predict_goods_amount : (item.original && item.original.goods_amount ? item.original.goods_amount : 0);
                item.score = item.score || 1;
                item.goods_unit_name = item.goods_unit_name || item.sales_unit;
                item.supplier_goods_name = item.supplier_goods_name || item.predict_goods_name || '';
                item.exists_order_goods_replace = !!(item.other_options && item.other_options.length);
                item.index = index;
                _this.otherOptionsBak.push(item);
            });
        }
    };
    OCRUpload.prototype.importGood = function () {
        if (!this.otherOptionsBak || !this.otherOptionsBak.length) {
            this.$message.error('暂无可导入货品');
            return;
        }
        var data = this.otherOptionsBak || [];
        data.length && data.forEach(function (item) {
            item.order_detail_oamount = item.amount;
            item.order_detail_uprice = item.order_detail_uprice ? item.order_detail_uprice : 0;
            item.order_detail_money = 0;
            item.order_detail_tax_money = 0;
            item.money = 0;
        });
        this.initData();
        this.$emit('importGood', data);
    };
    OCRUpload.prototype.debounce = function (cb) {
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
            cb();
        }, 500);
    };
    OCRUpload.prototype.initData = function () {
        this.imageUrl = [];
        this.uploadFinished = false;
        this.goodList = [];
        this.unmatchedGoodList = [];
        this.similarGoodList = [];
        this.otherOptionsBak = [];
        this.dialogWidth = '640px';
        if (this.$refs.drawer) {
            this.$refs.drawer.closeDrawer();
        }
        if (this.$refs.uploaderRef) {
            this.$refs.uploaderRef.clear();
        }
    };
    OCRUpload.prototype.changeGood = function (row) {
        var _this = this;
        this.innerDrawer = true;
        this.currentGood = row.supplier_goods_name;
        var parent = document.getElementById('ocr-content-wrap');
        var child = document.getElementById('ocr-drawer-modal');
        if (child) {
            child.style.width = (parent.offsetWidth - 40) + 'px';
            child.style.height = (parent.offsetHeight - 40) + 'px';
        }
        var img = document.getElementById('ocr-upload-img');
        if (img) {
            img.style.height = (parent.offsetHeight - 170) + 'px';
        }
        this.similarGoodList = [];
        if (row && row.other_options && row.other_options.length) {
            row.other_options.map(function (item, index) {
                item.parentIndex = row.index;
                item.active = false;
                item.childIndex = index;
                _this.similarGoodList.push(item);
            });
        }
    };
    OCRUpload.prototype.deleteGood = function (row) {
        this.goodList = this.goodList.filter(function (item) { return item.goods_id !== row.goods_id; });
        this.computeGoodList();
    };
    OCRUpload.prototype.submitSelectedGood = function () {
        var _this = this;
        this.$refs.drawer.closeDrawer();
        var selectedGood = this.similarGoodList.find(function (item) { return item.active; });
        if (!selectedGood)
            return;
        var oldGood = _.cloneDeep(this.otherOptionsBak[selectedGood.parentIndex]);
        var oldSelected = _.cloneDeep(this.otherOptionsBak[selectedGood.parentIndex]);
        var selectedGoodBak = _.cloneDeep(selectedGood);
        delete selectedGoodBak.childIndex;
        delete selectedGoodBak.active;
        oldGood = __assign({}, oldGood, selectedGoodBak);
        oldGood.sales_unit = selectedGood.goods_unit_name;
        oldGood.supplier_goods_format = selectedGood.goods_format_name;
        var other_options = this.similarGoodList.filter(function (item) { return item.childIndex !== selectedGood.childIndex; }) || [];
        other_options.push(oldSelected);
        this.$set(this.goodList[selectedGood.parentIndex], 'supplier_goods_name', selectedGood.supplier_goods_name);
        this.$set(this.goodList[selectedGood.parentIndex], 'supplier_goods_name', selectedGood.supplier_goods_name);
        this.$set(this.goodList[selectedGood.parentIndex], 'supplier_goods_format', selectedGood.goods_format_name);
        this.$set(this.goodList[selectedGood.parentIndex], 'sales_unit', selectedGood.goods_unit_name);
        this.$set(this.goodList[selectedGood.parentIndex], 'goods_id', selectedGood.goods_id);
        this.$set(this.goodList[selectedGood.parentIndex], 'other_options', other_options);
        this.$set(this.goodList[selectedGood.parentIndex], 'main_pic', selectedGood.main_pic);
        this.$set(this.goodList[selectedGood.parentIndex], 'score', selectedGood.score);
        this.similarGoodList = [];
        this.otherOptionsBak[selectedGood.parentIndex] = oldGood;
        this.$forceUpdate();
        console.log('selectedGood==', selectedGood);
        var predict_goods_name = oldSelected.predict_goods_name;
        var params = {
            predict_goods_name: predict_goods_name,
            goods_id: selectedGood.goods_id
        };
        this.deliverService.updatePredictGoods(params).then(function (res) {
            if (res.data.success) {
                if (res.data.data) {
                    _this.otherOptionsBak[selectedGood.parentIndex] = __assign({}, oldGood, res.data.data);
                    _this.$forceUpdate();
                }
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.msg || err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    OCRUpload.prototype.toggleActive = function (item, index) {
        this.similarGoodList.forEach(function (good, i) {
            good.active = good.childIndex === item.childIndex ? !good.active : false;
        });
        this.$set(this, 'similarGoodList', this.similarGoodList);
        this.$forceUpdate();
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], OCRUpload.prototype, "uploadShow", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () { return { supplier_to_business_id: '', goods_format_ids: '' }; },
        })
    ], OCRUpload.prototype, "ocrParams", void 0);
    __decorate([
        Watch('uploadShow')
    ], OCRUpload.prototype, "uploadShowWatch", null);
    OCRUpload = __decorate([
        Component({
            computed: {
                noMatchedGoodCount: function () {
                    return this.unmatchedGoodList && this.unmatchedGoodList.length ? this.unmatchedGoodList.length : 0;
                },
                matchedGoodCount: function () {
                    if (this.goodList && this.goodList.length) {
                        var matchedList = this.goodList.filter(function (item) { return +item.is_identify === 1; }) || [];
                        return matchedList.length;
                    }
                    else {
                        return 0;
                    }
                },
                similarCount: function () {
                    return this.similarGoodList && this.similarGoodList.length ? this.similarGoodList.length : 0;
                },
            },
            components: {
                uploader: Uploader,
            }
        })
    ], OCRUpload);
    return OCRUpload;
}(Vue));
export default OCRUpload;
